<template v-editable="blok">
  <BaseButton
    :title="blok.text"
    :outlined="isOutlined"
    :link="isLink"
    :full-width="blok.mobile_full_width"
    @click="modal?.openModal"
  >
    <template v-if="blok.text" #text>
      {{ blok.text }}
    </template>
    <template v-if="blok.icon" #icon>
      <img v-if="blok.icon" :src="blok.icon.filename" alt="" />
    </template>
  </BaseButton>
  <BaseModal
    ref="modal"
    :small-padding="blok.small_padding"
    :hide-footer="blok.hide_footer"
    :max-width="blok.max_width"
    :is-centered="blok.is_centered"
  >
    <template v-if="blok.head && blok.head.length" #head>
      <StoryblokComponent v-for="el in blok.head" :key="el._uid" :blok="el" />
    </template>
    <template #body>
      <StoryblokComponent
        v-for="el in blok.content"
        :key="el._uid"
        :blok="el"
      />
    </template>
  </BaseModal>
</template>

<script lang="ts" setup>
import BaseModal from '@/components/base/BaseModal.vue'
import type { SbButtonModalStoryblok } from '@/types'
interface Props {
  blok: SbButtonModalStoryblok
}

const props = defineProps<Props>()
const modal = ref<InstanceType<typeof BaseModal>>()
const isOutlined = computed(() => props.blok.options === 'outlined')
const isLink = computed(() => props.blok.options === 'link')
</script>

<style lang="scss" scoped>
.button--icon {
  transition: transform 0.2s;
  &:hover {
    background-color: var(--cobalt-700);
    transform: scale(1.07);
  }
}
</style>
